import React, { useState, useEffect } from 'react';
import ReactCardFlip from 'react-card-flip';
import ProductModal from './ProductModal';
import useApi from '../../../../utils/api-manager/Helper/useApi';
import plus from '../../../../assets/Image/plus_dark.png';
import DeleteIcon from '../../../../assets/Image/remove.png';

const ProductSettings = () => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isConfigFlipped, setIsConfigFlipped] = useState(false);
  const [blocksData, setBlocksData] = useState(
    Array(49).fill(null).map((_, index) => ({
      title: '', price: 0, color: '', index, isSet: false
    }))
  );
  const [showModal, setShowModal] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const { Get, Patch } = useApi();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await Get('posItem');
      if (response) {
        const sortedResults = response.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
        const newBlocks = Array(49).fill(null).map((_, index) => ({
          title: '', price: 0, color: '', index, isSet: false
        }));
        const filledIndices = new Set();
        sortedResults.forEach((item) => {
          const index = parseInt(item.index);
          if (!isNaN(index) && index >= 0 && index < 49 && !filledIndices.has(index)) {
            newBlocks[index] = {
              id: item.id,
              title: item.title,
              price: item.price,
              color: item.color || item.colour,
              index,
              isSet: true
            };
            filledIndices.add(index);
          }
        });
        setBlocksData(newBlocks);
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const handleBlockClick = (block, index) => {
    setSelectedBlock({ ...block, index });
    setShowModal(true);
  };

  const handleDelete = async (e, blockId) => {
    e.stopPropagation();
    if (window.confirm('Delete this product?')) {
      try {
        await Patch('posItem', blockId, { is_deleted: true });
        fetchProducts();
      } catch (error) {
        console.error('Error deleting product:', error);
      }
    }
  };

  const getColor = (colour) => {
    const colorMap = {
      Red: "#EE6055",
      Blue: "#83D3F2",
      Green: "#ADF7B6",
      Lavender: "#BDB2FF",
      Peach: "#FFC89A",
    };
    return colorMap[colour] || colour || "#83D3F2";
  };

  const ProductGridView = () => (
    <div className="container-fluid p-2 p-md-3">
      <div className="row mb-3">
        <div className="col-12">
          <h3 className="h5 h-md-4">Product Settings</h3>
        </div>
      </div>
      <div className="row g-2 g-md-3">
        {blocksData.map((block, index) => (
          <div key={index} className="col-4 col-sm-3 col-md-2 col-lg-2 col-xl-1">
            <div
              className="ratio ratio-1x1 rounded-2 position-relative pos-product-card"
              style={{
                backgroundColor: block.isSet ? getColor(block.color) : 'transparent',
                border: block.isSet ? 'none' : '1px dashed rgba(148, 163, 184, 0.22)',
                opacity: block.isSet ? 1 : 0.42,
                cursor: 'pointer'
              }}
              onClick={() => handleBlockClick(block, index)}
            >
              <div className="d-flex flex-column align-items-center justify-content-center p-1 p-md-2">
                {block.isSet ? (
                  <>
                    <div className="text-center small fw-semibold text-truncate w-100 pos-product-card-title">
                      {block.title}
                    </div>
                    <div className="badge bg-dark bg-opacity-25 mt-1" style={{ fontSize: '0.65rem' }}>
                      ₹{parseFloat(block.price).toFixed(2)}
                    </div>
                    <button
                      className="btn btn-link p-0 position-absolute top-0 end-0 m-1"
                      onClick={(e) => handleDelete(e, block.id)}
                      style={{ width: '16px', height: '16px' }}
                    >
                      <img src={DeleteIcon} alt="Delete" className="w-100 h-100" />
                    </button>
                  </>
                ) : (
                  <img src={plus} alt="Add" style={{ width: '20px', height: '20px' }} />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const ProductListView = () => {
    const activeProducts = blocksData.filter(block => block.isSet);
    
    return (
      <div className="container-fluid p-2 p-md-3">
        <div className="row mb-3 align-items-center">
          <div className="col">
            <h3 className="h5 h-md-4 mb-0">Active Products ({activeProducts.length})</h3>
          </div>
          <div className="col-auto">
            <button
              onClick={() => setIsConfigFlipped(true)}
              className="btn btn-primary btn-sm"
            >
              Configure
            </button>
          </div>
        </div>
        <div className="row g-2 g-md-3">
          {activeProducts.length === 0 ? (
            <div className="col-12">
              <p className="text-center text-muted py-5">No products added yet</p>
            </div>
          ) : (
            activeProducts.map((block) => (
              <div key={block.index} className="col-12 col-md-6 col-lg-4">
                <div
                  className="card h-100 border"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleBlockClick(block, block.index)}
                >
                  <div className="card-body d-flex align-items-center justify-content-between p-2 p-md-3">
                    <div className="d-flex align-items-center gap-2 gap-md-3">
                      <div
                        className="rounded"
                        style={{
                          width: '40px',
                          height: '40px',
                          background: getColor(block.color)
                        }}
                      />
                      <div>
                        <div className="fw-semibold small">{block.title}</div>
                        <div className="text-muted" style={{ fontSize: '0.85rem' }}>
                          ₹{parseFloat(block.price).toFixed(2)}
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={(e) => handleDelete(e, block.id)}
                      className="btn btn-link p-1"
                    >
                      <img src={DeleteIcon} alt="Delete" style={{ width: '20px', height: '20px' }} />
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    );
  };

  const ConfigureView = () => (
    <div className="container-fluid p-2 p-md-3">
      <div className="row mb-3 align-items-center">
        <div className="col">
          <h3 className="h5 h-md-4 mb-0">Configure Products</h3>
        </div>
        <div className="col-auto">
          <button
            onClick={() => setIsConfigFlipped(false)}
            className="btn btn-secondary btn-sm"
          >
            Back to List
          </button>
        </div>
      </div>
      <div className="row g-1 g-md-2">
        {blocksData.map((block, index) => (
          <div key={index} className="col-3 col-sm-2 col-md-2 col-lg-1">
            <div
              className="ratio ratio-1x1 rounded position-relative pos-product-card"
              style={{
                backgroundColor: block.isSet ? getColor(block.color) : 'transparent',
                border: block.isSet ? 'none' : '1px dashed rgba(148, 163, 184, 0.22)',
                opacity: block.isSet ? 1 : 0.42,
                cursor: 'pointer'
              }}
              onClick={() => handleBlockClick(block, index)}
            >
              <div className="d-flex flex-column align-items-center justify-content-center p-1" style={{ fontSize: '0.65rem' }}>
                {block.isSet ? (
                  <>
                    <div className="text-center text-truncate w-100 fw-semibold pos-product-card-title">
                      {block.title}
                    </div>
                    <div style={{ fontSize: '0.6rem' }}>₹{parseFloat(block.price).toFixed(0)}</div>
                    <button
                      className="btn btn-link p-0 position-absolute top-0 end-0"
                      onClick={(e) => handleDelete(e, block.id)}
                      style={{ width: '12px', height: '12px', margin: '2px' }}
                    >
                      <img src={DeleteIcon} alt="Delete" className="w-100 h-100" />
                    </button>
                  </>
                ) : (
                  <img src={plus} alt="Add" style={{ width: '14px', height: '14px' }} />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="desktop-pos-container">
      <div className="desktop-pos-content">
        <div className="flip-card-container">
          <div className="flip-card-toggle" onClick={() => setIsFlipped(!isFlipped)}>
            <div className="toggle-text">
              {isFlipped ? 'View Grid' : 'View List'}
            </div>
          </div>
          <ReactCardFlip isFlipped={isFlipped} flipDirection="horizontal">
            <div key="front">
              <div className="order-details-container">
                <ProductGridView />
              </div>
            </div>
            <div key="back">
              <div className="order-details-container">
                <ProductListView />
              </div>
            </div>
          </ReactCardFlip>
        </div>

        <div className="product-containers">
          <ReactCardFlip isFlipped={isConfigFlipped} flipDirection="horizontal">
            <div key="front">
              <div className="order-details-container">
                <ProductListView />
              </div>
            </div>
            <div key="back">
              <div className="order-details-container">
                <ConfigureView />
              </div>
            </div>
          </ReactCardFlip>
        </div>
      </div>

      <ProductModal
        open={showModal}
        onClose={() => {
          setShowModal(false);
          setSelectedBlock(null);
        }}
        productData={selectedBlock}
        blockIndex={selectedBlock?.index}
        onSave={fetchProducts}
      />
    </div>
  );
};

export default ProductSettings;
